module.exports = __webpack_public_path__ + "static/img/IT11.44de5c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/IT11.jpg
// module id = e4OZ
// module chunks = 0